import { getUtilityComponents } from "../utility_component_registry";

export function UtilityComponentLoader() {
  return (
    <>
      {getUtilityComponents().map((component, i) => (
        <component.widget key={i} />
      ))}
    </>
  );
}
